/** The signed-in devices screen (docs/specs/identity.md). */
export const sessions = {
    title: "Sessions",
    description: "Devices where you're signed in. Sign out of any you don't recognise.",
    columns: { device: "Device", method: "Signed in with", signedIn: "Signed in", lastActive: "Last active" },
    method: { password: "Password", otp: "SMS code" },
    unknownDevice: "Unknown device",
    current: "This device",
    revoke: "Sign out",
    revokeTitle: "Sign out this device?",
    revokeBody: "That device will need to sign in again.",
    revoked: "The device has been signed out.",
    revokeAll: "Sign out everywhere",
    revokeAllTitle: "Sign out of every device?",
    revokeAllBody: "Every device, including this one, will need to sign in again.",
};
//# sourceMappingURL=sessions.js.map